import { Button, Chip } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CovepModal from "../../../components/Modal/Covep/CreateCovep";
import { Context } from "../../../context/context";
import { getSimulationById } from "../../../services/simulations-service";
import Loading from "../../../components/Loading/Loading.jsx";

import "./SimulationById.scss";
import {
  getKpercent,
  getExternalCommission,
  getInternalCommission,
  getK,
} from "../../../utils/maths";
import DoneSimulationModal from "../../../components/Modal/DoneSimulation/DoneSimulationModal";
import { getUserById } from "../../../services/user-service";
import { getCompanyById } from "../../../services/company-service";
import convertCommaToDot from "../../../utils/format-comma-to-dot";

export default function SimulationById() {
  const { sidebar } = useContext(Context);
  const accessToken = localStorage.getItem("token");
  const role = Number(localStorage.getItem("role"));

  const { id } = useParams();
  const [openCovep, setOpenCovep] = useState(false);
  const [openDone, setOpenDone] = useState(false);
  const [simulationData, setSimulationData] = useState({});
  const [company, setCompany] = useState({});
  const [user, setUser] = useState({});
  const k_percentual = getKpercent(simulationData.k, simulationData.preco);

  const novoK = getK(
    simulationData.preco + 0.03,
    simulationData.preco_compra,
    simulationData.icms || 0,
    simulationData.cec,
    simulationData.c_financeiro
  );

  const novoKpercentual = getKpercent(novoK, simulationData.preco + 0.03);

  const comissaoAtualInterna = getInternalCommission(
    simulationData.volume,
    simulationData.k,
    k_percentual,
    simulationData.product_id,
    simulationData.preco
  );

  const novaComissaoAtualInterna = getInternalCommission(
    simulationData.volume,
    novoK,
    novoKpercentual,
    simulationData.product_id,
    simulationData.preco
  );

  const comissaoAtualExterna = getExternalCommission(
    simulationData.volume,
    simulationData.k,
    k_percentual,
    simulationData.product_id,
    simulationData.preco
  );

  const novaComissaoAtualExterna = getExternalCommission(
    simulationData.volume,
    novoK,
    novoKpercentual,
    simulationData.product_id,
    simulationData.preco
  );

  const returnComission = () => {
    let userArla = user.comission_arla;
    let userDiesel = user.comission_diesel;

    if (user.comission_arla.includes(","))
      userArla = parseFloat(user.comission_arla.replace(/,/g, "."));
    if (user.comission_diesel.includes(","))
      userDiesel = parseFloat(user.comission_diesel.replace(/,/g, "."));

    userArla = Number(userArla);
    userDiesel = Number(userDiesel);

    if (simulationData.product_id === 3 && userArla > 0)
      return (simulationData.volume * simulationData.k * userArla).toFixed(2);
    if ([1, 2, 4, 5].includes(simulationData.product_id) && userDiesel > 0)
      return (simulationData.volume * simulationData.k * userDiesel).toFixed(2);

    if (user.permission_id === 5) return comissaoAtualExterna;
    if (user.permission_id === 6) return comissaoAtualInterna;

    return "";
  };

  const returnNewComission = () => {
    let userArla = user.comission_arla;
    let userDiesel = user.comission_diesel;

    if (user.comission_arla.includes(","))
      userArla = parseFloat(user.comission_arla.replace(/,/g, "."));
    if (user.comission_diesel.includes(","))
      userDiesel = parseFloat(user.comission_diesel.replace(/,/g, "."));

    if (user.comission_arla.includes(".")) userArla = Number(userArla);
    if (user.comission_diesel.includes(",")) userDiesel = Number(userDiesel);

    if (simulationData.product_id === 3 && userArla > 0)
      return (
        simulationData.volume *
        (simulationData.k + 0.03) *
        userArla
      ).toFixed(2);

    if ([1, 2, 4, 5].includes(simulationData.product_id) && userDiesel > 0)
      return (
        simulationData.volume *
        (simulationData.k + 0.03) *
        userDiesel
      ).toFixed(2);

    if (user.permission_id === 5) return novaComissaoAtualExterna;
    if (user.permission_id === 6) return novaComissaoAtualInterna;

    return "";
  };

  const isSimulationAllowed = (k_percentual) => {
    let userK = user.k;
    let userKarla = user.k_arla;
    let companyK = company.k_filial;
    let companyKArla = company.k_filial_arla;

    if (user.k.includes(",")) userK = convertCommaToDot(user.k);
    if (user.k_arla.includes(",")) userKarla = convertCommaToDot(user.k_arla);
    if (companyK.includes(",")) companyK = convertCommaToDot(company.k_filial);
    if (companyKArla.includes(","))
      companyKArla = convertCommaToDot(company.k_filial_arla);

    userK = +(Number(user.k) * 100).toFixed(2);
    userKarla = +(Number(user.k_arla) * 100).toFixed(2);
    companyK = +(Number(company.k_filial) * 100).toFixed(2);
    companyKArla = +(Number(company.k_filial) * 100).toFixed(2);

    // se o usuário tem K ou K arla definido

    if (userK > 0 || userKarla > 0) {
      if (simulationData.product_id === 3 && k_percentual < userKarla)
        return "Não permitido";
      if (simulationData.product_id === 3 && k_percentual >= userKarla)
        return "Permitido";

      if (
        [1, 2, 4, 5].includes(simulationData.product_id) &&
        k_percentual < userK
      ) {
        return "Não permitido";
      }

      if (
        [1, 2, 4, 5].includes(simulationData.product_id) &&
        k_percentual >= userK
      ) {
        return "Permitido";
      }
    }

    // se existe o k da filial diesel

    if (companyK > 0 && [1, 2, 4, 5].includes(simulationData.product_id)) {
      if (simulationData.product_id === 3 && k_percentual < companyK) {
        return "Não permitido";
      }

      if (simulationData.product_id === 3 && k_percentual >= companyK) {
        return "Permitido";
      }

      if (
        [1, 2, 4, 5].includes(simulationData.product_id) &&
        k_percentual < companyK
      )
        return "Não permitido";
      if (
        [1, 2, 4, 5].includes(simulationData.product_id) &&
        k_percentual >= companyK
      )
        return "Permitido";
    }

    // se existe o k da filial arla

    if (companyKArla > 0 && simulationData.product_id === 3) {
      if (simulationData.product_id === 3 && k_percentual < companyKArla) {
        return "Não permitido";
      }

      if (simulationData.product_id === 3 && k_percentual >= companyKArla) {
        return "Permitido";
      }

      if (
        [1, 2, 4, 5].includes(simulationData.product_id) &&
        k_percentual < companyKArla
      )
        return "Não permitido";
      if (
        [1, 2, 4, 5].includes(simulationData.product_id) &&
        k_percentual >= companyKArla
      )
        return "Permitido";
    }

    if (simulationData.product_id === 3 && k_percentual <= 10)
      return "Não permitido";
    if (simulationData.product_id === 3 && k_percentual >= 10)
      return "Permitido";
    if ([1, 2, 4, 5].includes(simulationData.product_id) && k_percentual < 3.5)
      return "Não permitido";
    if ([1, 2, 4, 5].includes(simulationData.product_id) && k_percentual >= 3.5)
      return "Permitido";

    return "";
  };

  useEffect(() => {
    async function getData() {
      const result = await getSimulationById(accessToken, id);
      const user = await getUserById(accessToken, result.user_id);
      const company = await getCompanyById(accessToken, result.company_id);
      setCompany(company);
      setSimulationData(result);
      setUser(user);
    }
    getData();
    // teste
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {openDone && (
        <DoneSimulationModal
          id={simulationData.id}
          open={openDone}
          setOpen={setOpenDone}
        />
      )}
      {openCovep ? (
        <CovepModal
          simulationData={simulationData}
          open={openCovep}
          setOpen={setOpenCovep}
        />
      ) : (
        ""
      )}
      {simulationData.id ? (
        <main className={sidebar ? "container" : "container-full"}>
          <div className="title-and-chip">
            <h1>{`Simulação ${simulationData.id}`}</h1>

            <div className="simulations__chip">
              {simulationData.status === "pendente" && (
                <Chip color="primary" label="Pendente" />
              )}
              {simulationData.status === "concluida" && (
                <Chip color="success" label="Concluída" />
              )}
              {simulationData.status === "covep" && (
                <Chip color="error" label="Covep" />
              )}
            </div>
          </div>
          <div className="simulations">
            <div className="simulations__data">
              {/* <p>{`K da Simulação: ${simulationData.k}`}</p> */}
              <p>{`K% = ${k_percentual}% - ${isSimulationAllowed(
                k_percentual
              )}`}</p>

              {/* {[5, 6].includes(role) && (
                <> */}
              <p>Comissão: R$ {returnComission()}</p>
              <p>{`Se você vender a R$ ${(simulationData.preco + 0.03).toFixed(
                2
              )}, sua comissão irá para R$ ${returnNewComission()}`}</p>
              {/* </>
              )} */}

              {role === 1 ? (
                <>
                  <p>Comissão atual interna: R$ {comissaoAtualInterna}</p>
                  <p>Comissão atual externa: R$ {comissaoAtualExterna}</p>
                  <p>{`Novo K após R$ 0.03 em centavos: ${novoK}`}</p>
                  <p>{`Novo K% após R$ 0.03 em porcentagem: ${novoKpercentual}`}</p>
                  <p>
                    Nova Comissão atual interna: R$ {novaComissaoAtualInterna}
                  </p>
                  <p>
                    Nova Comissão atual externa: R$ {novaComissaoAtualExterna}
                  </p>
                  <p>{`Custo entrega cliente: ${simulationData.cec}`}</p>
                  <p>{`Custo Financeiro: ${simulationData.c_financeiro}`}</p>
                </>
              ) : (
                ""
              )}

              {simulationData.product_id === 1 && role === 1 && (
                <p>{`Produto: s-10 adt`}</p>
              )}
              {simulationData.product_id === 2 && role === 1 && (
                <p>{`Produto: s-500 adt`}</p>
              )}
              {simulationData.product_id === 3 && role === 1 && (
                <p>{`Produto: arla granel`}</p>
              )}
              {simulationData.product_id === 4 && role === 1 && (
                <p>{`Produto: s-10 comum`}</p>
              )}
              {simulationData.product_id === 5 && role === 1 && (
                <p>{`Produto: s-500 comum`}</p>
              )}
            </div>

            <div className="simulations__btns">
              {simulationData.status !== "pendente" ? (
                ""
              ) : (
                <Button
                  size="medium"
                  variant="contained"
                  onClick={() => setOpenDone(true)}
                >
                  Cadastrar como venda concluída
                </Button>
              )}
              {simulationData.status !== "pendente" ? (
                ""
              ) : (
                <Button
                  size="medium"
                  onClick={() => setOpenCovep(true)}
                  variant="outlined"
                >
                  Cadastrar como covep
                </Button>
              )}
            </div>
          </div>
        </main>
      ) : (
        <main className={sidebar ? "container" : "container-full"}>
          <Loading />
        </main>
      )}
    </>
  );
}
